export function FullPageError() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-8 text-center">
      <h1 className="text-2xl font-semibold mb-2">Something went wrong</h1>
      <p className="text-muted-foreground mb-6">An unexpected error occurred. Please try refreshing the page.</p>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="inline-flex items-center justify-center rounded-pill px-4 py-2 text-sm font-semibold border border-border bg-card text-foreground hover:bg-accent hover:text-accent-foreground transition-colors cursor-pointer"
      >
        Refresh page
      </button>
    </div>
  );
}
